import {
  AngleTool,
  ArrowAnnotateTool,
  BidirectionalTool,
  CircleROITool,
  CobbAngleTool,
  EllipticalROITool,
  LengthTool,
  MagnifyTool,
  PanTool,
  PlanarFreehandROITool,
  ProbeTool,
  RectangleROITool,
  ReferenceLinesTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";

const SHORTCUT_LABEL_BY_TOOL_KEY = {
  [StackScrollTool.toolName]: "Y",
  [WindowLevelTool.toolName]: "W",
  [ZoomTool.toolName]: "Z",
  [PanTool.toolName]: null,
  [LengthTool.toolName]: "L",
  [EllipticalROITool.toolName]: "E",
  [RectangleROITool.toolName]: null,
  [BidirectionalTool.toolName]: null,
  [ProbeTool.toolName]: null,
  [ArrowAnnotateTool.toolName]: null,
  [AngleTool.toolName]: "A",
  [CobbAngleTool.toolName]: "C",
  [MagnifyTool.toolName]: null,
  [PlanarFreehandROITool.toolName]: null,
  [CircleROITool.toolName]: null,
  [ReferenceLinesTool.toolName]: null,
  Reset: "",
  Invert: "I",
  RotateRight: null,
  RotateLeft: null,
  FlipVertical: "V",
  FlipHorizontal: "H",
  AlignLeft: null,
  AlignRight: null,
  AlignCenter: null,
  Synchronize: null,
  CINE: null,
  MPR: null,
  Compare: null,
};

export function getBasicViewerToolShortcutLabel(toolKey) {
  if (toolKey == null || toolKey === "") {
    return null;
  }
  return SHORTCUT_LABEL_BY_TOOL_KEY[toolKey] ?? null;
}

/* Tooltip on main toolbar:: "Tool name (SHORTCUT)" when a shortcut exists.*/

export function formatBasicViewerToolTooltip(displayName, toolKey) {
  const sc = getBasicViewerToolShortcutLabel(toolKey);
  if (!sc) {
    return displayName;
  }
  return `${displayName} (${sc})`;
}

const UI_SHORTCUT_LABEL = {
  series: "S",
  report: "R",
};

export function formatBasicViewerUiTooltip(displayName, uiKey) {
  const sc = UI_SHORTCUT_LABEL[uiKey];
  if (!sc) {
    return displayName;
  }
  return `${displayName} (${sc})`;
}

/** Right-click context menu actions */
const CONTEXT_ACTION_SHORTCUT = {
  deleteSelected: "SHIFT + D, DELETE",
  deleteAll: "CTRL/CMD + DELETE",
};

export function getBasicViewerContextActionShortcut(actionKey) {
  if (actionKey == null || actionKey === "") {
    return null;
  }
  return CONTEXT_ACTION_SHORTCUT[actionKey] ?? null;
}
